import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppRedirect = () => {
  const handleWhatsAppRedirect = () => {
    const phoneNumber = "+916006089901";
    const message =
      "Hello! I'm interested in knowing more about your services.";
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.location.href = whatsappURL;
  };

  return (
    <div>
      <button
        type="button"
        onClick={handleWhatsAppRedirect}
        className="text-green-500 hover:text-green-600"
        title="Chat with us on WhatsApp"
        aria-label="Chat with us on WhatsApp"
      >
        <FaWhatsapp size={50} />
        {/* <IoLogoWhatsapp size={50} /> */}
      </button>
    </div>
  );
};

export default WhatsAppRedirect;
